Avatar.theme = Avatar.theme || {};

Avatar.theme.BlogTagFilter = function BlogTagFilter() {
  var selectors = {
    blogTags: '[data-blog-tag-filter]'
  };

  function filterByTag() {
    var blogTags = document.querySelectorAll(selectors.blogTags);
    if (!blogTags.length) return;
    blogTags.forEach(function (tag) {
      tag.addEventListener('change', function (evt) {
        location.href = evt.target.value;
      });
    });
  }

  filterByTag();
  return {
    filterByTag: filterByTag
  };
}();